import { useGetClosingPackageProjectionQuery } from '../api/closingPackageApi';
import type { ClosingPackageProjection } from '../types';

/**
 * Thin projection hook for Closing Package Workspace (FE-002+).
 * Keeps host components from depending on raw RTK endpoint names.
 */
export function useClosingPackageProjection(applicationId: number | null | undefined) {
  const skip = applicationId == null || !Number.isFinite(Number(applicationId)) || Number(applicationId) <= 0;

  return useGetClosingPackageProjectionQuery(Number(applicationId), {
    skip,
  });
}

export type UseClosingPackageProjectionResult = ReturnType<typeof useClosingPackageProjection> & {
  projection: ClosingPackageProjection | undefined;
};
